import { NaniumObject, Type } from 'nanium/objects';

export class ReviewSummaryTextBlocks extends NaniumObject<ReviewSummaryTextBlocks> {
	@Type(Array, String) 'hzb': string[];
	@Type(Array, String) 'mzb': string[];
	@Type(Array, String) 'lang': string[];
	@Type(Array, String) 'other': string[];
	@Type(Array, String) 'admissionRequirement': string[];
	@Type(Array, String) 'remarks': string[];
}

export class Settings extends NaniumObject<Settings> {
	@Type(String) id: string;
	@Type(ReviewSummaryTextBlocks) reviewSummaryTextBlocks: ReviewSummaryTextBlocks;
}
